import { createContext, useContext, useEffect, useState } from "react"
import moment from "moment"
import { CondominiosContext } from "../CondominiosContext/CondominiosContext"
import { WebSocketContext } from "../WebSocket/WebSocketContext"
import { showNotify } from "../../Utils/Utils"
import { VisitantesContext } from "../VisitantesContext/VisitantesContext"

export const EncomendaContex = createContext()

export const EncomendaProvader = ({ children }) => {
    const { activeCond } = useContext(CondominiosContext)
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { tabIndex } = useContext(VisitantesContext)

    const [resultEntregas, setResultEntregas] = useState([])
    const [resultEntregasFuturas, setResultEntregasFuturas] = useState([])
    const [adicionaUmNovo, setAdicionaUmNovo] = useState(false)
    const [loading, setLoading] = useState(false)
    const [filtro, setFiltro] = useState(null)

    const [ultimaPesquisa, setUltimaPesquisa] = useState(null)

    useEffect(() => {
        setResultEntregas([])
        setResultEntregasFuturas([])
        setFiltro(null)
        setLoading(false)
    }, [activeCond, tabIndex])

    const procurarEncomenda = (pesquisa) => {
        if (filtro == null && pesquisa == undefined) {
            pesquisa = {
                id_central: activeCond.id_central,
                status: 0,
                data_inicial: moment().subtract(15, 'days').format('yyyy-MM-DD HH:mm'),
                data_final: moment().add(15, 'days').format('yyyy-MM-DD HH:mm')
            }
        }

        if (pesquisa) {
            setFiltro(pesquisa)
            setLoading(true)
            sendWs("BuscarEncomendas", pesquisa)
        }

        if (!pesquisa && filtro) {
            setLoading(true)
            sendWs("BuscarEncomendas", filtro)
        }
    }

    const getEntregas = (msg) => {
        if (msg.data.status !== 'error') {
            if (msg.data.encomendas.length > 0) {
                setResultEntregas(msg.data.encomendas)
            } else {
                setResultEntregas([])
            }

            if (msg.data.futuras.length > 0) {
                setResultEntregasFuturas(msg.data.futuras)
            } else {
                setResultEntregasFuturas([])
            }

            if (msg.data.futuras.length < 0 && msg.data.encomendas.length < 0) {
                showNotify("warning", `Nenhum dado encontrado`)
            }
        } else {
            setResultEntregas([])
            setResultEntregasFuturas([])
            showNotify("warning", `Erro ao Buscar lista de encomendas`)
        }

        setLoading(false)
    }

    addRoute("BuscarEncomendas", getEntregas)

    const salvarUltimaPesquisa = (pesquisa) => {
        setUltimaPesquisa(pesquisa)
    }

    const procurarUltimaPesquisa = () => {
        if (ultimaPesquisa) {
            procurarEncomenda(ultimaPesquisa)
        }
    }

    const value = {
        procurarEncomenda,
        resultEntregas,
        setResultEntregas,
        resultEntregasFuturas,
        setResultEntregasFuturas,
        loading,
        setLoading,
        adicionaUmNovo,
        setAdicionaUmNovo,
        salvarUltimaPesquisa,
        procurarUltimaPesquisa
    }

    return (
        <EncomendaContex.Provider value={value}>
            {children}
        </EncomendaContex.Provider>
    )
}
